import FormControl from '@mui/material/FormControl';
import type { SxProps, Theme } from '@mui/material/styles';

import Autocomplete from 'shared/atoms/Autocomplete';
import type { AutocompleteOption } from 'shared/atoms/Autocomplete';
import type { BackgroundThemes } from 'shared/const';

import FormLabel from '../components/FormLabel';
import type { FormFieldProperties } from '../FormInput';

interface FormAutocompleteProps {
  disabled?: boolean;
  handleChange?: (params: { name: string; value: unknown }) => void;
  id: string;
  infoText?: string;
  label: string;
  name: string;
  properties?: Record<string, FormFieldProperties>;
  required?: boolean;
  sx?: SxProps<Theme>;
  theme?: BackgroundThemes;
  values?: Record<string, unknown>;
  [key: string]: unknown; // Allow other Autocomplete props
}

const FormAutocomplete = ({
  disabled: disabledProp,
  handleChange,
  id,
  infoText,
  label,
  name,
  properties = {},
  required: requiredProp,
  sx = {},
  theme: themeLayout = 'dark',
  values = {},
  ...props
}: FormAutocompleteProps) => {
  const { disabled, required } = properties[name] || {};

  const onChangeHandler = (value: unknown | null) => {
    handleChange?.({ name, value });
  };

  return (
    <FormControl
      disabled={disabledProp === undefined ? disabled : disabledProp}
      fullWidth
      required={requiredProp === undefined ? required : requiredProp}
      sx={sx}
    >
      <FormLabel
        id={id}
        infoText={infoText}
        label={label}
        theme={themeLayout}
      />
      <Autocomplete
        disabled={disabledProp === undefined ? disabled : disabledProp}
        onChange={onChangeHandler}
        preSelectedValue={values[name] as AutocompleteOption | null | undefined}
        theme={themeLayout}
        {...props}
      />
    </FormControl>
  );
};

export default FormAutocomplete;
export type { FormAutocompleteProps };
